module.exports = __webpack_public_path__ + "img/horizontal_6_3_8004.c6054f90.png";